import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { FormControl, FormControlLabel, InputBase, MenuItem, Select, Switch } from "@material-ui/core";
import { EventType } from "pages/statuses/EventType";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            // margin: theme.spacing(5),
            // marginBottom: theme.spacing(1),
            // color: `black`,
            width: `800px`,
            minWidth: `600px`,
        },
        formControl: {
            // margin: theme.spacing(1),
            // minWidth: 60,
        },
        cautions: {
            color: `black`,
            fontSize: `small`,
            border: `1px solid`,
            borderColor: `red`,
            marginTop: theme.spacing(1),
            padding: `5px`,
        },
    })
);

interface Props {
    // 予約情報
    booking: EventType;
    // 表示モード
    mode: `edit` | `confirm`;
    // ローディング状態のセッター
    setLoading: any;
}

/**
 * 廃薬品コンポーネント
 * 廃薬品の個数選択コンポーネント
 */
export const WasteChemicals: React.FC<Props> = (props) => {
    const { booking, mode, setLoading } = props;
    const classes = useStyles();
    const [num, setNum] = React.useState(booking.numberOfChemicals ? booking.numberOfChemicals : ``);
    const [state, setState] = React.useState({
        checked: num !== `` ? true : false,
    });
    const switchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.checked) {
            booking.numberOfChemicals = undefined;
            setNum(``);
        } else {
            booking.numberOfChemicals = 1;
            setNum(1);
        }
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    const selectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        booking.numberOfChemicals = event.target.value as number;
        setNum(event.target.value as number);
    };
    
    /**
     * 編集モードか
     *
     * @param mode 表示モード（編集 or 確認）
     * @returns 編集モードか
     */
    const isEditMode = (mode: `edit` | `confirm`): boolean => {
        return mode === `edit`;
    };

    return (
        <div className={classes.form}>
            {isEditMode(mode) ? (
                <>
                    <div>
                        <FormControlLabel
                            control={<Switch checked={state.checked} onChange={switchChange} name="checked" />}
                            label="廃薬品"
                        />
                        {state.checked === true && (
                        <>
                            <FormControl className={classes.formControl}>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={num}
                                    onChange={selectChange}
                                >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                </Select>
                            </FormControl>
                        </>
                        )}
                        <div className={classes.cautions}>
                            ※廃薬品がある場合は、スイッチをONし、数量を選択(4点まで)。下記の廃薬品回収依頼票を記載し、環境安全センターに回収前日の12：00までにメールにてお送りください。5点以上の場合はご相談ください。
                            <br />
                            　メールアドレス：env_pres@rs.tus.ac.jp
                            <br />
                            　廃薬品回収依頼票URL：https://www.rs.kagu.tus.ac.jp/env_pres/experimental/　から「神楽坂キャンパス」を開き、様式をダウンロードしてください。
                            <br />
                            ※廃液回収時にはマスク、手袋各自持参
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <InputBase
                        value={num}
                    />
                </>
            )}
        </div>
    );
};
